import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { HttpService } from "../../../../core";
import { SelectionModel } from "@angular/cdk/collections";
import { UserService } from "../../../../core/services/user.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-user-select",
  templateUrl: "user-selection.component.html",
  styleUrls: ["./user-selection.component.scss"],
})
export class UserSelectionComponent implements OnInit {
  displayedColumns: string[] = ["select", "email", "Full name", "role"];
  dataSource = [];
  selection = new SelectionModel<any>(true, []);
  // formerSelectedUsers = [];
  // formerSelectedUserIds = [];

  existingUsers = [];
  selectedLength: any;

  constructor(
    private httpService: HttpService,
    private userService: UserService,
    private toastrService: ToastrService,
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    console.log(this.data);
    // this.selection = this.data.selectedUsers;
    // this.formerSelectedUsers = this.data.selectedUsers;
    // this.formerSelectedUsers.forEach(user => {
    //   this.formerSelectedUserIds.push(user.id);
    // })

    // console.log(this.formerSelectedUsers);

    this.userService.currentUser.subscribe((res: any) => {
      if (this.userService.getCurrentUser().roles[0]?.id !== 4) {
        this.httpService.getAllUsersByCompany().subscribe((r: any) => {
          this.dataSource = r.data;
          console.log(this.dataSource, "this.dataSource");
          this.dataSource.forEach((item: any) => {
            item.email = this.userService.getEmailFromContacts(item.contacts);
            item.fullName = item.firstName + " " + item.lastName;
          });
          this.existingUsers = this.data.selectedUsers;
          if (this.existingUsers) {
            // const arr=[]
            this.existingUsers.forEach((user) => {
              this.dataSource.forEach((u) => {
                if (u.id == user.id) {
                  this.selection.select(u);
                  this.selectedLength = this.selection.selected.length;
                }
              })
            });
            // this.existingUsers.forEach((user) => {
            //   const temp = this.dataSource.filter((u: any) => u.id == user.id);
            //   if (temp.length != 0) {
            //     this.selection.select(temp[0]);
            //     console.log(this.selection.selected.length, "this.selection");
            //     this.selectedLength = this.selection.selected.length;
            //   }
            // });
          }
        });
      }
    });
  }

  confirm() {
    // const selectedUsers = [];
    // this.selection.selected.forEach(user => {
    //   selectedUserIds.push(user.id);
    // })
    console.log(this.selection);
    const selectedId = [];
    this.selection.selected.map((user) => {
      if (user) {
        selectedId.push(user.id);
      }
    });
    console.log(selectedId);
    this.userService.currentUser.subscribe((user: any) => {
      selectedId.push(user.id);
      console.log(selectedId);
      console.log(this.unique(selectedId));
    });

    const fd = new FormData();
    fd.append("userIds", this.unique(selectedId).toString());
    console.log(this.data.projectId);
    this.httpService
      .updateProject(fd, this.data.projectId)
      .subscribe((res: any) => {
        console.log("updateProject", res);
        if (res.code === 1) {
          this.dialogRef.close({ users: res.data.users, code: 1 });
        } else {
          this.dialogRef.close({ code: 0 });
        }
      });
  }

  cancel() {
    // const selectedUsers = [];
    // this.selection.selected.forEach(user => {
    //   selectedUserIds.push(user.id);
    // })
    console.log(this.selection.selected);
    this.dialogRef.close();
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.length;
    // const numFormerselectedUsers = this.formerSelectedUsers.length;
    // console.log( numSelected === numRows || numFormerselectedUsers === numRows);
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    console.log(this.isAllSelected())
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.forEach((row) => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    // console.log(this.selection.toggle(row));

    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.position + 1
      }`;
  }

  unique(arr) {
    if (!Array.isArray(arr)) {
      console.log("not an array");
      return;
    }
    const array = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < arr.length; i++) {
      if (array.indexOf(arr[i]) === -1) {
        array.push(arr[i]);
      }
    }
    return array;
  }
}
